const SDK_VERSION = '7.88.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
